import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title" }, [
    /*#__PURE__*/_createElementVNode("h2", null, "Statement")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "card-toolbar" }, [
    /*#__PURE__*/_createElementVNode("ul", {
      class: "nav nav-stretch fs-5 fw-bold nav-line-tabs nav-line-tabs-2x border-transparent",
      role: "tablist"
    }, [
      /*#__PURE__*/_createElementVNode("li", {
        class: "nav-item",
        role: "presentation"
      }, [
        /*#__PURE__*/_createElementVNode("a", {
          class: "nav-link text-active-primary active",
          "data-bs-toggle": "tab",
          role: "tab",
          href: "#kt_customer_view_statement_1"
        }, " This Year ")
      ]),
      /*#__PURE__*/_createElementVNode("li", {
        class: "nav-item",
        role: "presentation"
      }, [
        /*#__PURE__*/_createElementVNode("a", {
          class: "nav-link text-active-primary ms-3",
          "data-bs-toggle": "tab",
          role: "tab",
          href: "#kt_customer_view_statement_2"
        }, " 2020 ")
      ]),
      /*#__PURE__*/_createElementVNode("li", {
        class: "nav-item",
        role: "presentation"
      }, [
        /*#__PURE__*/_createElementVNode("a", {
          class: "nav-link text-active-primary ms-3",
          "data-bs-toggle": "tab",
          role: "tab",
          href: "#kt_customer_view_statement_3"
        }, " 2019 ")
      ]),
      /*#__PURE__*/_createElementVNode("li", {
        class: "nav-item",
        role: "presentation"
      }, [
        /*#__PURE__*/_createElementVNode("a", {
          class: "nav-link text-active-primary ms-3",
          "data-bs-toggle": "tab",
          role: "tab",
          href: "#kt_customer_view_statement_4"
        }, " 2018 ")
      ])
    ])
  ])
], -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "card-body pb-5" }, [
  /*#__PURE__*/_createElementVNode("div", {
    id: "kt_customer_view_statement_tab_content",
    class: "tab-content"
  }, [
    /*#__PURE__*/_createElementVNode("div", {
      id: "kt_customer_view_statement_1",
      class: "py-0 tab-pane fade active show",
      role: "tabpanel"
    }),
    /*#__PURE__*/_createElementVNode("div", {
      id: "kt_customer_view_statement_2",
      class: "py-0 tab-pane fade",
      role: "tabpanel"
    }),
    /*#__PURE__*/_createElementVNode("div", {
      id: "kt_customer_view_statement_3",
      class: "py-0 tab-pane fade",
      role: "tabpanel"
    }),
    /*#__PURE__*/_createElementVNode("div", {
      id: "kt_customer_view_statement_4",
      class: "py-0 tab-pane fade",
      role: "tabpanel"
    })
  ])
], -1)
const _hoisted_3 = [
  _hoisted_1,
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(`card ${_ctx.cardClasses}`)
  }, _hoisted_3, 2))
}